import { getNameSurname } from './getNameSurname';

export const getClientSummary = (client: { name?: string; surname?: string; age?: number }) =>
  `${getNameSurname(client)}${client.age ? `, ${client.age}` : ''}`;
